export const kioskReleaseKeysResource = {
  name: 'Release key',
  none: 'This deployment has no release key yet. Create it before uploading releases. Kiosks pin this key when they are enrolled.',
  active: 'Active key',
  fingerprint: 'Fingerprint',
  keyId: 'Key id',
  createdAt: 'Created',
  createdBy: 'Created by',
  history: 'Earlier keys',
  retiredAt: 'Retired',
  retiredBy: 'Retired by',
  replacedReason: 'Reason this key replaced the previous one',
  statuses: { active: 'Active', retired: 'Retired', abandoned: 'Abandoned' },
  actions: {
    create: 'Create release key',
    rotate: 'Rotate key',
    replace: 'Replace lost key',
    check: 'Check the key file',
    checkFile: 'Check key file',
    register: 'Use this key',
    download: 'Download the key file',
    close: 'Close',
  },
  create: {
    intro: 'The key is made in this browser. Only its public half is sent to the server. The secret half is saved as a password-protected key file on this computer and never leaves it.',
    password: 'Password (16 to 128 characters)',
    confirm: 'Type the password again',
    saved: 'The key file was downloaded. Keep two copies in two places, and keep the password apart from both. A lost key file or password cannot be recovered.',
    checkIntro: 'Choose the downloaded key file and type its password, to prove it opens.',
    card: 'Write the key card now: deployment, key id and fingerprint. Installers compare it at every enrolment.',
  },
  rotate: {
    intro: 'Load the current key file, then make the new key. Kiosks accept the new key because the current key signs it.',
    currentFile: 'Current key file',
    currentPassword: 'Password of the current key file',
    done: 'Rotated. Kiosks take the new key at their next heartbeat. Rewrite the key card.',
  },
  replace: {
    warning: 'Use this only when the key file or its password is lost, or the key may be stolen. No kiosk will trust the new key until an administrator resets the kiosk\'s release key and pins the new one, kiosk by kiosk.',
    reason: 'Why is the key being replaced?',
    confirm: 'Type REPLACE to continue',
    target: 'This replaces the key %{fingerprint}.',
    stale: 'The release key changed while this dialog was open, so nothing was replaced. Close this dialog and open Replace lost key again to review the key that is active now.',
  },
  closeConfirm: {
    line: 'The key file was downloaded, but this key is not in use yet. If you close now, that file will not be used.',
    close: 'Close anyway',
    keep: 'Keep working',
  },
  check: {
    intro: 'Choose a release key file and type its password. This checks that the file opens and which key it holds. Nothing is signed and nothing leaves this browser.',
    active: 'This key file opens with this password and holds the active release key.',
    earlier: 'This key file opens, but it holds an earlier key (%{status}). It cannot sign new releases.',
    unknown: 'This key file opens, but this deployment does not know its key. Check that it is the right file for this console.',
  },
  errors: {
    password_too_short: 'Use at least 16 characters.',
    password_too_long: 'Use at most 128 characters.',
    password_not_ascii: 'Use letters, digits, spaces and punctuation from a standard keyboard only.',
    passwords_differ: 'The two passwords differ.',
    file_not_json: 'This is not a key file.',
    file_invalid: 'This is not a valid release key file.',
    password_wrong: 'The password is wrong, or the file was changed.',
    key_mismatch: 'The key file is damaged.',
    ed25519_unavailable: 'This browser cannot make or use Ed25519 keys. Use a current Chrome, Edge, Firefox or Safari.',
    not_active_key: 'This key file is not this deployment\'s active release key.',
    placeholder_missing: 'This manifest has no "key_id":"unsigned". Choose the unsigned manifest from the build.',
    placeholder_repeated: 'This manifest names "key_id":"unsigned" more than once.',
    manifest_not_utf8: 'The manifest is not UTF-8 text.',
    package_mismatch: 'The package does not match the manifest (size or SHA-256).',
    not_downloaded_key: 'This is not the key file that was just downloaded. Choose that file.',
    deployment_differs: 'This key file was made for %{deployment}, not this console (%{origin}).',
    deployment_invalid: 'This console\'s server address is not a valid release key deployment. Check the admin build\'s API address.',
    crypto_failed: 'This browser could not run the key file\'s encryption. Use a current Chrome, Edge, Firefox or Safari.',
  },
};

export const kioskReleaseKeys = kioskReleaseKeysResource;
